import { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./quento.css";
import { useAudio } from "../../../Providers/AudioProvider";
import task from "../Task";
import useUserInfo from "../../../Hooks/useUserInfo";
import { userGameRewards, getUserDetails1 } from "../../../apis/user";
import { logPageView } from "../../../components/analytics";
import vibrateDevice, {
  vibrateSuccess,
  vibrateError,
} from "../../../utils/vibration";

// Add this CSS class at the top of the file or in your CSS file
const loadingOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const loadingSpinnerStyle = {
  width: "25px",
  height: "25px",
  border: "3px solid rgba(243, 243, 243, 0.16)",
  borderTop: "3px solid rgb(15, 116, 25)",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
};

export default function QuentoGame() {
  const [board, setBoard] = useState([]);
  const [path, setPath] = useState([]);
  const [expression, setExpression] = useState("");
  const [result, setResult] = useState(null);
  const [target, setTarget] = useState(null);
  const [touchStart, setTouchStart] = useState(null);
  const gameBoardRef = useRef(null);
  const [gameState, setGameState] = useState({
    isOver: false,
    score: 0,
    timeLeft: 60,
    isActive: false,
    isLoading: false,
    showGameOverPopup: false,
  });
  const [difficultyLevel, setDifficultyLevel] = useState("easy");
  const [showInstructions, setShowInstructions] = useState(false);
  const [highScore, setHighScore] = useState(0);
  const [apiHighScore, setApiHighScore] = useState(0);
  const [apiCallMade, setApiCallMade] = useState(false);
  const { userDetails, updateUserInfo, updatewatchScreenInfo, watchScreen } =
    useUserInfo();
  const playClick = useAudio();

  const closePopUp = () => {
    playClick();
    vibrateDevice();
    setGameState((prev) => ({
      ...prev,
      isOver: false,
      isActive: false,
      score: 0,
      showGameOverPopup: false,
      isLoading: false,
    }));
    setApiCallMade(false);
  };
  const IsPointsReached =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;
  const toogleMenu = () => {
    playClick();
    vibrateDevice();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  // Add meta viewport and prevent iOS gestures
  useEffect(() => {
    // Add meta viewport tag to prevent zooming
    const viewportMeta = document.createElement("meta");
    viewportMeta.name = "viewport";
    viewportMeta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
    document.head.appendChild(viewportMeta);

    // Prevent Telegram vertical swipe behavior
    if (window.Telegram && window.Telegram.WebApp) {
      // Using the proper WebApp API method to disable vertical swipes
      // This prevents the app from collapsing when swiping inside the game area
      if (typeof window.Telegram.WebApp.disableVerticalSwipes === "function") {
        window.Telegram.WebApp.disableVerticalSwipes();
      } else {
        // Fallback for older versions that don't have the disableVerticalSwipes method
        const data = JSON.stringify({
          eventType: "web_app_setup_swipe_behavior",
          eventData: {
            allow_vertical_swipe: false,
          },
        });

        // Handle different Telegram environments
        if (window.TelegramWebviewProxy) {
          // Desktop and Mobile
          window.TelegramWebviewProxy.postEvent(
            "web_app_setup_swipe_behavior",
            JSON.stringify({ allow_vertical_swipe: false })
          );
        } else if (window.external && window.external.notify) {
          // Windows Phone
          window.external.notify(data);
        } else {
          // Web version
          window.parent.postMessage(data, "*");
        }
      }
    }

    // Prevent iOS-specific gestures that cause Telegram mini app to minimize
    const preventDefaultForTouch = (e) => {
      // Don't prevent default for buttons and interactive elements
      if (
        e.target.tagName === "BUTTON" ||
        e.target.closest("button") ||
        e.target.role === "button" ||
        e.target.className.includes("btn") ||
        e.target.onclick
      ) {
        return; // Allow buttons to work
      }

      // Prevent default for game board elements
      if (
        gameBoardRef.current &&
        (gameBoardRef.current.contains(e.target) ||
          e.target === gameBoardRef.current)
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    // Add event listeners with passive: false to ensure preventDefault works
    document.addEventListener("touchstart", preventDefaultForTouch, {
      passive: false,
    });
    document.addEventListener("touchmove", preventDefaultForTouch, {
      passive: false,
    });
    document.addEventListener("touchend", preventDefaultForTouch, {
      passive: false,
    });

    // Add specific iOS body styling to prevent bouncing/scrolling
    document.body.style.overscrollBehavior = "none";
    document.body.style.overflow = "hidden";

    // Clean up when component unmounts
    return () => {
      document.head.removeChild(viewportMeta);
      document.removeEventListener("touchstart", preventDefaultForTouch);
      document.removeEventListener("touchmove", preventDefaultForTouch);
      document.removeEventListener("touchend", preventDefaultForTouch);
      document.body.style.overscrollBehavior = "";
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    logPageView("quento ", "quento");
  }, []);

  // Fetch initial highscore from API and local storage
  useEffect(() => {
    const fetchHighScore = async () => {
      try {
        // Get local storage highscore
        const localHighScore = localStorage.getItem("quentoHighScore");
        const localScore = localHighScore ? parseInt(localHighScore) : 0;
        console.log("🏆 Local highscore:", localScore);

        // Fetch API highscore
        const response = await getUserDetails1();
        console.log("🏆 API response:", response);
        console.log("🏆 API response keys:", Object.keys(response || {}));
        console.log("🏆 Game rewards:", response?.gameRewards);
        console.log(
          "🏆 Game rewards keys:",
          Object.keys(response?.gameRewards || {})
        );
        console.log("🏆 Games array:", response?.gameRewards?.games);
        console.log(
          "🏆 Games array length:",
          response?.gameRewards?.games?.length
        );

        // Try different possible locations for the highscore
        let apiScore = 0;
        if (response?.gameRewards?.quentoHighScore) {
          apiScore = parseInt(response.gameRewards.quentoHighScore);
          console.log("🏆 Found in gameRewards.quentoHighScore:", apiScore);
        } else if (response?.gameRewards?.games) {
          // Look for quento game in the games array
          const quentoGame = response.gameRewards.games.find(
            (game) => game.gameType === "quento"
          );
          if (quentoGame) {
            console.log("🏆 Found quento game:", quentoGame);
            apiScore = quentoGame.highScore
              ? parseInt(quentoGame.highScore)
              : 0;
            console.log(
              "🏆 Found in games array quentoGame.highScore:",
              apiScore
            );
          } else {
            console.log("🏆 No quento game found in games array");
          }
        } else if (response?.quentoHighScore) {
          apiScore = parseInt(response.quentoHighScore);
          console.log("🏆 Found in response.quentoHighScore:", apiScore);
        } else {
          console.log("🏆 No quentoHighScore found in any location");
        }
        console.log("🏆 Final API highscore:", apiScore);

        // Set both scores
        setHighScore(localScore);
        setApiHighScore(apiScore);

        // Use the higher of the two scores
        const maxScore = Math.max(localScore, apiScore);
        console.log("🏆 Max score:", maxScore);

        if (maxScore > 0) {
          setHighScore(maxScore);
          setApiHighScore(maxScore);
          // Update local storage with the higher score
          localStorage.setItem("quentoHighScore", maxScore.toString());
          console.log("🏆 Updated highscore to:", maxScore);
        }
      } catch (error) {
        console.error("Error fetching highscore:", error);
        // Fallback to local storage only
        const localHighScore = localStorage.getItem("quentoHighScore");
        if (localHighScore) {
          setHighScore(parseInt(localHighScore));
        }
      }
    };
    fetchHighScore();
  }, []);

  const handleApiResponse = async (points) => {
    console.log("🎮 handleApiResponse called with points:", points);
    console.log("🎮 gameState.isLoading:", gameState.isLoading);
    console.log("🎮 apiCallMade:", apiCallMade);

    // Prevent multiple API calls
    if (gameState.isLoading || apiCallMade) {
      console.log(
        "🚫 API call blocked - already in progress or points awarded"
      );
      return;
    }

    setGameState((prev) => ({ ...prev, isLoading: true }));
    setApiCallMade(true);

    // Update highscore if current score is higher
    const currentScore = points;
    const newHighScore = Math.max(highScore, apiHighScore, currentScore);
    if (currentScore > highScore) {
      setHighScore(currentScore);
      localStorage.setItem("quentoHighScore", currentScore.toString());
    }

    // Only call API if there are points to submit
    if (points > 0) {
      try {
        const apiData = {
          gamePoints: points,
          gameType: "quento",
        };

        const res = await Promise.race([
          userGameRewards(apiData),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Timeout")), 5000)
          ),
        ]);

        if (res) {
          updatewatchScreenInfo((prev) => ({
            ...prev,
            LoginMessage: res?.message,
          }));

          // Update API highscore from response
          if (res?.gameRewards?.quentoHighScore) {
            const apiScore = parseInt(res.gameRewards.quentoHighScore);
            setApiHighScore(apiScore);
          }
        }
      } catch (error) {
        console.error("API call failed:", error);
      }
    }

    // Always show popup regardless of score
    setGameState((prev) => ({
      ...prev,
      isLoading: false,
      isOver: true,
      showGameOverPopup: true,
      isActive: false,
    }));
  };

  // Generate a new board based on difficulty level
  const generateBoard = () => {
    // Different board sizes based on difficulty
    let gridSize;
    let numberRange;
    let operators;

    switch (difficultyLevel) {
      case "easy":
        gridSize = 3;
        numberRange = 9;
        operators = ["+", "-"];
        break;
      case "medium":
        gridSize = 4;
        numberRange = 12;
        operators = ["+", "-", "×"];
        break;
      case "hard":
        gridSize = 4;
        numberRange = 15;
        operators = ["+", "-", "×", "÷"];
        break;
      default:
        gridSize = 3;
        numberRange = 9;
        operators = ["+", "-"];
    }

    const newBoard = [];
    const totalCells = gridSize * gridSize;

    // Generate positions for numbers and operators
    for (let i = 0; i < totalCells; i++) {
      const row = Math.floor(i / gridSize);
      const col = i % gridSize;

      // Alternate between numbers and operators
      const isEvenRow = row % 2 === 0;
      const isEvenCol = col % 2 === 0;
      const isNumber = (isEvenRow && isEvenCol) || (!isEvenRow && !isEvenCol);

      if (isNumber) {
        newBoard.push({
          id: i,
          value: Math.floor(Math.random() * numberRange) + 1,
          type: "number",
          row,
          col,
        });
      } else {
        newBoard.push({
          id: i,
          value: operators[Math.floor(Math.random() * operators.length)],
          type: "operator",
          row,
          col,
        });
      }
    }

    return newBoard;
  };

  // Generate target number
  const generateTarget = (board) => {
    // Create a valid path to ensure solvability
    let possiblePath;
    let calculatedResult;
    let attempts = 0;
    const maxAttempts = 10;
    const usedTargets = new Set(); // Track used targets

    // Keep trying until we get a unique, positive result
    do {
      possiblePath = createValidPath(board);
      calculatedResult = calculateExpression(
        possiblePath.map((cell) => cell.value).join(" ")
      );
      attempts++;

      // If we've tried too many times, force a new path
      if (attempts >= maxAttempts) {
        // Shuffle the board to get a completely new arrangement
        const shuffledBoard = [...board].sort(() => Math.random() - 0.5);
        board.length = 0;
        board.push(...shuffledBoard);
        attempts = 0;
      }
    } while (
      calculatedResult < 1 ||
      !Number.isInteger(calculatedResult) ||
      usedTargets.has(calculatedResult)
    );

    // Add the new target to used targets
    usedTargets.add(calculatedResult);

    // Round to avoid decimal issues and ensure positive
    return Math.abs(Math.round(calculatedResult));
  };

  // Create a valid path through the board
  const createValidPath = (board) => {
    const gridSize = Math.sqrt(board.length);
    // Get all number cells
    const numberCells = board.filter((cell) => cell.type === "number");

    // Shuffle the number cells to get a random starting point
    const shuffledNumberCells = [...numberCells].sort(
      () => Math.random() - 0.5
    );
    let currentCell = shuffledNumberCells[0];

    const validPath = [currentCell];
    const visitedCells = new Set([currentCell.id]);

    // Length of path: alternating between number and operator (3-7 cells total)
    const targetLength = Math.floor(Math.random() * 3) * 2 + 3; // 3, 5, or 7

    while (validPath.length < targetLength) {
      // Find adjacent cells
      const adjacentCells = board.filter((cell) => {
        const rowDiff = Math.abs(cell.row - currentCell.row);
        const colDiff = Math.abs(cell.col - currentCell.col);
        return (
          (rowDiff === 1 && colDiff === 0) || (rowDiff === 0 && colDiff === 1)
        );
      });

      // Filter by correct type (alternating number/operator) and not already in path
      const validNextCells = adjacentCells.filter((cell) => {
        const expectedType = validPath.length % 2 === 0 ? "number" : "operator";
        return cell.type === expectedType && !visitedCells.has(cell.id);
      });

      if (validNextCells.length === 0) {
        // If no valid moves, try a different starting point
        if (shuffledNumberCells.length > 1) {
          shuffledNumberCells.shift(); // Remove the current starting point
          currentCell = shuffledNumberCells[0];
          validPath.length = 0;
          validPath.push(currentCell);
          visitedCells.clear();
          visitedCells.add(currentCell.id);
          continue;
        }
        // If no more starting points, create a new path
        return createValidPath(board);
      }

      // Choose random next cell
      currentCell =
        validNextCells[Math.floor(Math.random() * validNextCells.length)];
      validPath.push(currentCell);
      visitedCells.add(currentCell.id);
    }

    return validPath;
  };

  // Start a new game
  const startGame = () => {
    const newBoard = generateBoard();
    const newTarget = generateTarget(newBoard);

    setBoard(newBoard);
    setTarget(newTarget);
    setPath([]);
    setExpression("");
    setResult(null);
    setTouchStart(null); // Clear touch state
    setGameState((prev) => ({
      ...prev,
      timeLeft: 60,
      isActive: true,
      isOver: false,
      showGameOverPopup: false,
      score: 0,
      isLoading: false,
    }));

    vibrateSuccess();
  };

  // Handle cell click
  const handleCellClick = (cell) => {
    if (!gameState.isActive) return;

    // Check if adjacent to last cell in path
    if (path.length > 0) {
      const lastCell = path[path.length - 1];
      const rowDiff = Math.abs(cell.row - lastCell.row);
      const colDiff = Math.abs(cell.col - lastCell.col);
      const isAdjacent =
        (rowDiff === 1 && colDiff === 0) || (rowDiff === 0 && colDiff === 1);

      // Check for alternating number/operator pattern
      const expectedType = path.length % 2 === 0 ? "number" : "operator";

      if (
        !isAdjacent ||
        cell.type !== expectedType ||
        path.find((p) => p.id === cell.id)
      ) {
        vibrateError();
        return;
      }
    } else if (cell.type !== "number") {
      vibrateError();
      return;
    }

    // Play click sound when a valid cell is selected
    playClick();
    vibrateDevice();

    const newPath = [...path, cell];
    setPath(newPath);

    const newExpression = newPath.map((item) => item.value).join(" ");
    setExpression(newExpression);

    // Only calculate if we have at least a number, operator, number sequence
    if (newPath.length >= 3 && newPath.length % 2 === 1) {
      const calculatedResult = calculateExpression(newExpression);
      setResult(calculatedResult);

      // Check if target is reached
      if (calculatedResult === target) {
        // Play sound for correct solution
        playClick();
        vibrateSuccess();
        setGameState((prev) => ({
          ...prev,
          score: prev.score + newPath.length * 10,
          timeLeft: prev.timeLeft + 15, // Add 15 seconds bonus time
        }));

        // Generate new target but keep the same board
        const newTarget = generateTarget(board);
        setTarget(newTarget);

        // Clear all states immediately and synchronously
        setPath([]);
        setExpression("");
        setResult(null);
        setTouchStart(null);

        // Force a complete re-render by updating the board
        setBoard((prevBoard) => {
          // Create a completely new board array to force re-render
          return prevBoard.map((cell) => ({ ...cell }));
        });

        // Additional cleanup with a longer delay to ensure complete clearing
        setTimeout(() => {
          setPath([]);
          setExpression("");
          setResult(null);
          setTouchStart(null);
          // Force another board update to ensure visual clearing
          setBoard((prevBoard) => prevBoard.map((cell) => ({ ...cell })));
        }, 100);
      }
    }
  };

  // Calculate expression result
  const calculateExpression = (expr) => {
    try {
      const tokens = expr.split(" ");
      let result = parseFloat(tokens[0]);

      for (let i = 1; i < tokens.length; i += 2) {
        const operator = tokens[i];
        const operand = parseFloat(tokens[i + 1]);

        if (operator === "÷" && operand === 0) {
          throw new Error("Division by zero");
        }

        switch (operator) {
          case "+":
            result += operand;
            break;
          case "-":
            result -= operand;
            break;
          case "×":
            result *= operand;
            break;
          case "÷":
            result /= operand;
            break;
          default:
            throw new Error("Invalid operator");
        }
      }

      return result;
    } catch (error) {
      console.error("Error calculating expression:", error);
      return null;
    }
  };

  // Reset the current path
  const resetPath = () => {
    playClick();
    vibrateDevice();
    setPath([]);
    setExpression("");
    setResult(null);
  };

  // Timer effect
  useEffect(() => {
    let timer;
    if (gameState.isActive && gameState.timeLeft > 0 && !showInstructions) {
      timer = setInterval(() => {
        setGameState((prev) => {
          if (prev.timeLeft <= 1) {
            // Call API when time runs out
            handleApiResponse(prev.score);
            return {
              ...prev,
              timeLeft: 0,
              isActive: false,
            };
          }
          return {
            ...prev,
            timeLeft: prev.timeLeft - 1,
          };
        });
      }, 1000);
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [gameState.isActive, gameState.timeLeft, showInstructions]);

  // Handle touch start
  const handleTouchStart = (e) => {
    if (!gameState.isActive) return;

    const touch = e.touches[0];
    const element = document.elementFromPoint(touch.clientX, touch.clientY);
    if (!element) return;

    const cellId = element.getAttribute("data-cell-id");
    if (!cellId) return;

    const cell = board.find((c) => c.id === parseInt(cellId));
    if (!cell) return;

    setTouchStart(cell);
    handleCellClick(cell);
  };

  // Handle touch move
  const handleTouchMove = (e) => {
    if (!touchStart || !gameState.isActive) return;

    const touch = e.touches[0];
    const element = document.elementFromPoint(touch.clientX, touch.clientY);
    if (!element) return;

    const cellId = element.getAttribute("data-cell-id");
    if (!cellId) return;

    const cell = board.find((c) => c.id === parseInt(cellId));
    if (!cell) return;

    // Only process if it's a different cell
    if (cell.id !== touchStart.id) {
      handleCellClick(cell);
    }
  };

  // Handle touch end
  const handleTouchEnd = () => {
    setTouchStart(null);
  };

  // Render the board grid
  const renderBoard = () => {
    if (!board.length) return null;

    const gridSize = Math.sqrt(board.length);
    const getGridClass = () => {
      if (gridSize === 3) return "quento-grid-3";
      if (gridSize === 4) return "quento-grid-4";
      if (gridSize === 5) return "quento-grid-5";
      return "quento-grid-3";
    };

    return (
      <div
        ref={gameBoardRef}
        className={`quento-board ${getGridClass()} mb-4`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {board.map((cell) => {
          // Find position in path (if cell is in path)
          const pathIndex = path.findIndex((p) => p.id === cell.id);
          const isInPath = pathIndex !== -1;

          // Determine direction indicators based on position in path
          let directionIndicator = "";
          if (isInPath && pathIndex < path.length - 1) {
            const nextCell = path[pathIndex + 1];
            const rowDiff = nextCell.row - cell.row;
            const colDiff = nextCell.col - cell.col;

            if (rowDiff === 1) directionIndicator = "bi bi-arrow-down";
            else if (rowDiff === -1) directionIndicator = "bi bi-arrow-up";
            else if (colDiff === 1) directionIndicator = "bi bi-arrow-right";
            else if (colDiff === -1) directionIndicator = "bi bi-arrow-left";
          }

          // Cell background color based on position in path
          const cellStyle = isInPath
            ? {
                backgroundColor: `hsl(${120 + pathIndex * 20}, 70%, 40%)`,
                position: "relative",
                color: "white",
              }
            : {};

          return (
            <div
              key={cell.id}
              data-cell-id={cell.id}
              className={`game-tile ${cell.type} ${
                isInPath ? "path-cell" : ""
              } ${isInPath ? `path-${pathIndex}` : ""}`}
              onClick={() => handleCellClick(cell)}
              style={cellStyle}
            >
              {cell.value}
              {isInPath && (
                <div className="path-indicators">
                  {directionIndicator && (
                    <span className="direction-indicator">
                      <i className={directionIndicator}></i>
                    </span>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div
        className="menupointer game-container3"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          // flexDirection: "column",
          pointerEvents: "fill",
          // background: "rgb(28 28 28)",
        }}
      >
        <img
          onClick={() => {
            toogleMenu(task, "task");
          }}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
          className="cancel-full "
          style={{ cursor: "pointer" }}
        />

        {/* Best Score Display - Top Right Corner */}
        <div
          className="quento-best-score"
          style={{
            position: "fixed",
            top: "1%",
            right: "1%",
            // background: "rgba(0, 0, 0, 0.8)",
            color: "white",
            // padding: "10px 15px",
            // borderRadius: "10px",
            // border: "2px solid #00ff41",
            zIndex: 1000,
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            textAlign: "center",
            gap: "5px",
            minWidth: "120px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          }}
        >
          <div style={{ fontSize: "12px", marginBottom: "0px", opacity: 0.8 }}>
            BEST SCORE
          </div>
          <div style={{ fontSize: "18px", color: "#00ff41" }}>
            {(() => {
              const displayScore = Math.max(highScore, apiHighScore);
              console.log("🏆 Display score calculation:");
              console.log("🏆 highScore:", highScore);
              console.log("🏆 apiHighScore:", apiHighScore);
              console.log("🏆 displayScore:", displayScore);
              return displayScore;
            })()}
          </div>
        </div>

        <div className="container">
          <div className="row justify-content-center w-100">
            <div className="col-12 col-md-12 col-lg-6">
              <div className="game-container2">
                {!gameState.isActive && (
                  <div className="card-header text-center text-white position-relative">
                    <h2 className="mb-0 text-uppercase welcome-text">
                      Quento Game
                    </h2>
                  </div>
                )}
                <div className="game-content">
                  {!gameState.isActive && (
                    <div className="text-center mb-4">
                      <h3 className="mb-3 text-white text-uppercase">
                        Select Difficulty:
                      </h3>
                      <div className="difficulty-buttons mb-4" role="group">
                        <button
                          className={`difficulty-btn ${
                            difficultyLevel === "easy" ? "active" : ""
                          }`}
                          onClick={() => {
                            playClick();
                            vibrateDevice();
                            setDifficultyLevel("easy");
                          }}
                        >
                          Easy
                        </button>
                        <button
                          className={`difficulty-btn ${
                            difficultyLevel === "medium" ? "active" : ""
                          }`}
                          onClick={() => {
                            playClick();
                            vibrateDevice();
                            setDifficultyLevel("medium");
                          }}
                        >
                          Medium
                        </button>
                        <button
                          className={`difficulty-btn ${
                            difficultyLevel === "hard" ? "active" : ""
                          }`}
                          onClick={() => {
                            playClick();
                            vibrateDevice();
                            setDifficultyLevel("hard");
                          }}
                        >
                          Hard
                        </button>
                      </div>
                      <button
                        className="start-btn"
                        onClick={() => {
                          playClick();
                          vibrateDevice();
                          startGame();
                        }}
                      >
                        Start Game
                      </button>

                      {gameState.score > 0 && (
                        <div className="mt-3">
                          <p className="lead text-white text-uppercase">
                            Your previous score:{" "}
                            <strong>{gameState.score}</strong>
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  {gameState.isActive && (
                    <>
                      <div className="stats-row mb-3">
                        <div className="stat-item">
                          <span className="stat-label text-uppercase">
                            Score:
                          </span>
                          <span className="stat-value">{gameState.score}</span>
                        </div>
                        <div className="stat-item">
                          <span className="stat-label text-uppercase">
                            Time:
                          </span>
                          <span
                            className={`stat-value ${
                              gameState.timeLeft < 10 ? "text-danger" : ""
                            }`}
                          >
                            {gameState.timeLeft}s
                          </span>
                        </div>
                        <div className="stat-item">
                          <button
                            className="help-icon"
                            onClick={() => {
                              playClick();
                              vibrateDevice();
                              setShowInstructions(true);
                            }}
                            title="How to Play"
                            style={{ color: "white" }}
                          >
                            <i
                              className="bi bi-question-circle"
                              // style={{ fontSize: "1.0rem" }}
                            ></i>
                          </button>
                        </div>
                      </div>

                      <div className="target-display mb-3">
                        <h5 className="target-label text-uppercase">Target:</h5>
                        <h3 className="target-value">{target}</h3>
                      </div>

                      {renderBoard()}

                      <div className="expression-display mb-3">
                        <h5 className="expression-label text-uppercase">
                          Current Expression
                        </h5>
                        <p className="expression-value">
                          {expression || "—"} :{result}
                        </p>
                        {/* <p className="expression-value">Total:{result}</p> */}
                        {/* 
                        {result !== null && (
                          <p
                            className={`result-value ${
                              result === target ? "text-success" : ""
                            }`}
                          >
                            = {result}
                          </p>
                        )} */}
                      </div>

                      <div className="text-center">
                        <button
                          className="control-btn"
                          onClick={() => {
                            playClick();
                            resetPath();
                          }}
                        >
                          Clear Path
                        </button>
                      </div>
                    </>
                  )}

                  {gameState.isLoading && (
                    <div style={loadingOverlayStyle}>
                      <div style={loadingSpinnerStyle}></div>
                    </div>
                  )}

                  {(() => {
                    console.log("🎮 Popup condition check:");
                    console.log(
                      "🎮 gameState.showGameOverPopup:",
                      gameState.showGameOverPopup
                    );
                    console.log("🎮 gameState.isLoading:", gameState.isLoading);
                    console.log("🎮 gameState.isOver:", gameState.isOver);
                    return gameState.showGameOverPopup && !gameState.isLoading;
                  })() && (
                    <div className="overlay">
                      <div className="quento-full-popup">
                        <div className="quento-popup-content">
                          <h2 className="quento-epic">Game Over!</h2>
                          <img
                            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                            className="quento-cancel-img"
                            onClick={closePopUp}
                          />
                          <div className="row text-center">
                            <div className="col-12">
                              <div
                                className="quento-epic-div"
                                style={{ padding: "30px 40px" }}
                              >
                                <p className="quento-pointsLabel">
                                  {gameState.score > 0
                                    ? "TOKENS EARNED"
                                    : "GAME OVER"}
                                </p>
                                <div className="quento-pointsValue1">
                                  <img
                                    src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png"
                                    alt="logo"
                                  />
                                  <p className="quento-pointsNumber">
                                    {gameState.score}
                                  </p>
                                </div>
                                <div className="mt-3">
                                  <p
                                    className="quento-pointsLabel"
                                    style={{
                                      fontSize: "16px",
                                      margin: "10px 0",
                                    }}
                                  >
                                    Best Score:{" "}
                                    {Math.max(highScore, apiHighScore)}
                                  </p>
                                </div>
                              </div>
                              <p className="quento-bottom-text">
                                {gameState.score > 0
                                  ? "Great job! 🎉 Challenge yourself to beat your high score!"
                                  : "Keep practicing! 🧩 Try to solve more puzzles next time!"}
                              </p>
                              <button
                                className="control-btn"
                                onClick={() => {
                                  playClick();
                                  vibrateDevice();
                                  startGame();
                                }}
                              >
                                Play Again
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Instructions Modal */}
                  {showInstructions && (
                    <div className="modal-overlay">
                      <div
                        className="modal-content"
                        style={{
                          background: "#0c6421",
                          padding: "5px",
                          borderRadius: "4px",
                        }}
                      >
                        <div
                          className="modal-header"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <div style={{ width: "30px" }}></div>
                          <h5 className="modal-title text-center text-white text-uppercase">
                            How to Play Quento
                          </h5>
                          <button
                            type="button"
                            className="btn btn-sm text-white"
                            onClick={() => {
                              playClick();
                              vibrateDevice();
                              setShowInstructions(false);
                            }}
                            aria-label="Close"
                          >
                            <i className="bi bi-x-circle fs-4"></i>
                          </button>
                        </div>
                        <div className="modal-body">
                          <ul className="list-group">
                            <li className="list-group-item text-uppercase">
                              <i className="bi bi-check-circle fs-4 me-2"></i>
                              Connect adjacent numbers and operators
                            </li>
                            <li className="list-group-item text-uppercase">
                              <i className="bi bi-123 fs-4 me-2"></i>
                              Start with a number, then operator, then number
                            </li>
                            <li className="list-group-item text-uppercase">
                              <i className="bi bi-bullseye fs-4 me-2"></i>
                              Make equations equal to the target value
                            </li>
                            <li className="list-group-item text-uppercase">
                              <i className="bi bi-trophy fs-4 me-2"></i>
                              Score points based on path length
                            </li>
                            <li className="list-group-item text-uppercase">
                              <i className="bi bi-clock fs-4 me-2"></i>
                              Get bonus time for correct solutions!
                            </li>
                          </ul>
                        </div>
                        <div className="modal-footer justify-content-center">
                          <button
                            type="button"
                            className="text-uppercase control-btn mt-1 mb-1"
                            onClick={() => {
                              playClick();
                              vibrateDevice();
                              setShowInstructions(false);
                            }}
                          >
                            Got it!
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
